import { render, staticRenderFns } from "./IncomingPickup.vue?vue&type=template&id=38d226b9&scoped=true"
import script from "./IncomingPickup.vue?vue&type=script&lang=js"
export * from "./IncomingPickup.vue?vue&type=script&lang=js"
import style0 from "./IncomingPickup.vue?vue&type=style&index=0&id=38d226b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d226b9",
  null
  
)

export default component.exports